import styled from "styled-components";

import {
  Button,
  Card,
  CardHeader,
  Fab,
  Grid,
  IconButton,
} from "@material-ui/core";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { DeleteForever, Edit } from "@material-ui/icons";

export const GridContainer = styled(Grid)``;

export const GridContent = styled(Grid)`
  width: 50%;
`;

export const Title = styled.h2``;

export const CardContent = styled.div``;

export const OrderedListContent = styled.ol``;

export const MemoryRuleContainer = styled.li`
  margin-bottom:10px;
  margin-top:10px; 
`;

export const MemoryRuleContent = styled.div`
  display: flex;
  align-items:center;
  justify-content:space-between;
`;

export const MemoryRuleCard = styled(Card)`
  width:75%;
  background: #c9c9c9;
`;

export const CardTitle = styled(CardHeader)``;

export const RulesCardList = styled.li`
  margin-bottom:10px;
  margin-top:10px; 
`;

export const RulesContainer = styled.div`
  display: flex;
  align-items:center;
  justify-content:space-between;
`;

export const RulesCard = styled(Card)`
  width:75%;
`;

export const RulesTitle = styled(CardHeader)``;

export const ArrowContainer = styled.div`
  width:100px;
  display: flex;
  align-items:center;
  justify-content:center;
`;

export const ArrowButton = styled(IconButton)``;

export const ArrowUp = styled(ArrowUpward)``;

export const ArrowDown = styled(ArrowDownward)``;

export const IconsContainer = styled.div`
  width: 25%;
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content:space-evenly;
`;

export const EditButton = styled(Fab)`
  border: 1px solid;
  border-color: #63afef;
  background: transparent;
  box-shadow: unset;

  &:hover{
    background: transparent;
  }
`;

export const EditIcon = styled(Edit)`
  color: #63afef;
`;

export const DeleteButton = styled(Fab)`
  border: 1px solid;
  border-color: #ED5565;
  background: transparent;
  box-shadow: unset;

  &:hover{
    background: transparent;
  }
`;

export const DeleteIcon = styled(DeleteForever)`
  color:#ED5565;
`;

export const ContainerButtons = styled.div`
  width:90%;
  margin-top:28px;
  display:flex;
  align-items:center;
  justify-content:space-around;
`;

export const CreateRuleButton = styled(Button)`
  border-radius:20px;
`;

export const SaveButton = styled(Fab)``;
